document.addEventListener('DOMContentLoaded', function () {
  const images = document.querySelectorAll('.fade-in-image');

  images.forEach((img) => {
    // Function to add the 'loaded' class
    const addLoadedClass = () => {
      img.classList.add('loaded');
    };

    // Check if the image is already loaded (from cache)
    if (img.complete) {
      addLoadedClass();
    } else {
      // Add event listener for the load event
      img.addEventListener('load', addLoadedClass);

      // Optional: Handle error if image fails to load
      img.addEventListener('error', () => {
        console.error(`Image failed to load: ${img.src}`);
        // You can add a fallback class or image here
      });
    }
  });
});
